(()=>{
  document.addEventListener('DOMContentLoaded', () => {
    const filterWrapperButtons = document.querySelector('.Collection--header__filter-wrapper--buttons');
    const filterWrapperFilters = document.querySelector('.Collection--header__filter-wrapper--filters');
    const filterWrapperSort = document.querySelector('.js-sort-wrapper');
    const filterWrapperView = document.querySelector('.view_detail_box');
    const collectionHero = document.querySelector('.collection-hero');

    let options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if(filterWrapperButtons) filterWrapperButtons.classList.remove('floating-buttons');
          if(filterWrapperFilters) filterWrapperFilters.classList.remove('floating-filters');
          if(filterWrapperSort) filterWrapperSort.classList.remove('floating-sorts');
          if(filterWrapperView) filterWrapperView.classList.remove('floating-view');
        } else {
          if(filterWrapperButtons) filterWrapperButtons.classList.add('floating-buttons');
          if(filterWrapperFilters) filterWrapperFilters.classList.add('floating-filters');
          if(filterWrapperSort) filterWrapperSort.classList.add('floating-sorts');
          if(filterWrapperView) filterWrapperView.classList.add('floating-view');
        }
      });
    }, options);

    if(collectionHero) observer.observe(collectionHero);
  });
})();

